import {motion} from 'framer-motion';
import { useState } from 'react';



export function Row({ children, vcenter = false }) {
    return (
        <div className={`rowroot ${vcenter ? 'rvaligncenter' : 'rvalignstart'}`}>
            {children}
        </div>
    );
}


export function TextBlock({ children, align, side = 'left' }) {

    if (!Array.isArray(children)) {
        children = [children];
    }
    
    children = children.map((val, i) => <p key = {i} className={`text ${align} text${side}`}>{val}</p>);

    return (
        <div>{children}</div>
    );
}


const diagvars = {
    'right' : {
        transform : `translate(4rem, 0)`,
        opacity : 0,
    },
    'left' : {
        transform : `translate(-4rem, 0)`,
        opacity : 0,
    },
    'normal' : {
        transform : `translate(0, 0)`,
        opacity : 1,
    },
};

export function Diagram({ src, caption, height, width, side, scale = false, center = false }) {
    return (
        <motion.div style={{
            display : 'flex',
            flexDirection : 'column',
            padding : '0.5rem',
            height : 'fit-content',
            width : 'fit-content',
            margin : '1rem',
            alignSelf : center ? 'center' : null,
            zIndex : 0
        }} 
            variants = {diagvars}
            initial = {side}
            whileInView = {'normal'}
        >
            <motion.img src={src} 
                className="diagramimg " style={{
                    height : height,
                    width : width,
                    // objectPosition : `${tx} ${ty}`
                }}
                height={height}
                width={width}
                whileHover={{ scale : scale ? 1.2 : 1 }}
            />
            <div
                style={{
                    display : 'flex',
                    flexDirection : 'row',
                    justifyContent : 'center',
                    alignItems : 'center',
                    marginTop : '0.5rem',
                    opacity : 0.5,
                    fontSize : '0.7rem'
                }}
            >{caption}</div>
        </motion.div>
    );
}


export function Divider({ mode }) {
    return (
        <div style={{
            height : 0,
            width : '100%',
            border : `1px solid ${mode === 'light' ? 'black' : 'white'}`,
            marginTop : '0.2rem',
            opacity : 0.5
        }}>
        </div>
    );
}




const dbvars = {
    'light' : {
        'border': '0.1rem solid rgb(0, 0, 0)',
        'border-bottom': '0.4rem solid black'
    },
    'dark' : {
        'border': '0.1rem solid rgb(255, 255, 255)',
        'border-bottom': '0.4rem solid white'
    },
};

export function DownloadButton({ mode, text = 'Download', filename, filepath }) {
    return (
        <motion.div
            variants={dbvars}
            initial={mode}
            animate={mode}
            style={{
                cursor : 'pointer',
                height : 'fit-content',
                width : 'fit-content',
                padding : '0.6rem',
                fontSize : 'inherit',
                border : `0.1rem solid ${mode === 'light' ? 'black' : 'white'}`,
                borderRadius : '0.5rem',
                userSelect : 'none'
            }}
            whileHover={{
                'border-bottom': (mode === 'light') ? '0.25rem solid rgb(0, 0, 0)' : '0.25rem solid rgb(255, 255, 255)'
            }}
            whileTap={{
                'border-bottom': (mode === 'light') ? '0.1rem solid rgb(0, 0, 0)' : '0.1rem solid rgb(255, 255, 255)'
            }}
            onClick={() => {
                const link = document.createElement('a');
                link.href = filepath; // Set the href attribute to the file path
                link.download = filename; // Set the download attribute to the file name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }}
        >
            {text}
        </motion.div>
    );
}



export function Heading({ children, size = 'h2' }) {
    const [op, setop] = useState(0);

    let divid = '';
    
    if (children) { 
        divid = children.split(' ');
        divid = divid.map(val => val.toLowerCase());
        divid = divid.join('_');
    }

    let head = null;
    if (size === 'h1') head =  <h1 id={divid}>{children}</h1>;
    if (size === 'h2') head =  <h2 id={divid}>{children}</h2>;
    if (size === 'h3') head =  <h3 id={divid}>{children}</h3>;

    return (
        <div onMouseEnter={() => setop(0.5)} onMouseLeave={() => setop(0)}>
            <motion.div 
                className='anchor'
                initial = {{ opacity : op }}
                animate = {{ opacity : op }}
                transition={{ duration : 0.1 }}
                onClick={() => {
                    navigator.clipboard.writeText(`stealthypanda.github.io/whatisx/transformers/index.html#${divid}`);
                }}
            >#</motion.div>
            {head}
        </div>
    );
}

